import React from "react";
import { SkeletonText } from "@calcom/ui";

export function BookingSuccessSkeleton() {
  return (
    <div className="mx-auto max-w-3xl animate-pulse px-4 py-8">
      <div className="rounded-lg bg-white p-8 shadow-sm dark:bg-gray-900">
        <div className="mx-auto mb-6 h-12 w-12 rounded-full bg-gray-200 dark:bg-gray-800" />

        <div className="mb-10 flex flex-col items-center space-y-3">
          <SkeletonText className="h-8 w-64" /> {/* Main Title */}
          <SkeletonText className="h-4 w-48" /> {/* Subtitle */}
        </div>

        <div className="space-y-8 border-t border-gray-100 pt-8 dark:border-gray-800">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="grid grid-cols-3 gap-4">
              <div className="col-span-1">
                <SkeletonText className="h-4 w-12" />
              </div>
              <div className="col-span-2 space-y-2">
                <SkeletonText className="h-4 w-full" />
                {item === 2 && <SkeletonText className="h-4 w-2/3" />} {/* Longer for 'When' */}
                {item === 3 && <SkeletonText className="h-4 w-1/2" />} {/* Extra line for 'Who' */}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-gray-100 pt-8 text-center dark:border-gray-800">
          <div className="flex justify-center space-x-2">
            <SkeletonText className="h-4 w-32" />
            <SkeletonText className="h-4 w-16 underline" />
          </div>
        </div>
      </div>

      <footer className="fixed bottom-0 left-0 right-0 border-t border-gray-200 bg-white px-8 py-4 dark:border-gray-800 dark:bg-black">
        <div className="mx-auto flex max-w-3xl justify-end">
          <SkeletonText className="h-10 w-40 rounded-md" />
        </div>
      </footer>
    </div>
  );
}
